module.exports = __webpack_public_path__ + "img/map_5.1c0c0db5.webp";